export enum BaseCardMessages {
  statusProgrammedLabelText = "baseCard.status.programmedLabelText",
  statusProgrammedPrefixText = "baseCard.status.programmedPrefixText",
  statusPreparingLabelText = "baseCard.status.preparingLabelText",
  statusInTransitLabelText = "baseCard.status.inTransitLabelText",
  statusInTransitPrefixText = "baseCard.status.inTransitPrefixText",
  statusInConstructionLabelText = "baseCard.status.inConstructionLabelText",
  statusInConstructionPrefixText = "baseCard.status.inConstructionPrefixText",
  statusInConstructionDescriptionText = "baseCard.status.inConstructionDescriptionText",
  statusDischargingLabelText = "baseCard.status.dischargingLabelText",
  statusDischargingPrefixText = "baseCard.status.dischargingPrefixText",
  statusDischargingDescriptionText = "baseCard.status.dischargingDescriptionText",
  statusDeliveredLabelText = "baseCard.status.deliveredLabelText",
  statusDeliveredDescriptionText = "baseCard.status.deliveredDescriptionText",
  statusCanceledLabelText = "baseCard.status.canceledLabelText",
  statusInvoiceIssuedLabelText = "baseCard.status.invoiceIssuedLabelText",
  statusInvoiceIssuedPrefixText = "baseCard.status.invoiceIssuedPrefixText",
  volumeText = "baseCard.volume.volumeText",
  volumeTotalText = "baseCard.volume.totalText",
  volumeDeliveredText = "baseCard.volume.deliveredText",
  volumeRemainingText = "baseCard.volume.remainingText",
  volumePriceText = "baseCard.volume.priceText",
  installmentNumberText = "baseCard.installment.numberText",
  installmentDueDateText = "baseCard.installment.dueDateText",
  installmentSettlementDateText = "baseCard.installment.settlementDateText",
  installmentNetValueText = "baseCard.installment.netValueText",
  travelEquipmentText = "baseCard.travel.equipmentText",
  travelPlateText = "baseCard.travel.plateText",
  travelDriverText = "baseCard.travel.driverText",
  travelProgrammedText = "baseCard.travel.programmedText",
  travelDocumentNumberText = "baseCard.travel.documentNumberText",
  travelLoadLabelText = "baseCard.travel.LoadLabelText",
  concreteRecipeText = "baseCard.concrete.recipeText",
  contractLabelText = "baseCard.contract.labelText",
  contractDateText = "baseCard.contract.dateText",
  contractSellerText = "baseCard.contract.sellerText",
  invoiceContractLabelText = "baseCard.invoice.contractLabelText",
  invoiceContractDateText = "baseCard.invoice.dateText",
  invoiceNumberText = "baseCard.invoice.numberText",
  invoiceDocumentTypeText = "baseCard.invoice.documentTypeText",
  invoiceTotalValueText = "baseCard.invoice.totalValueText",
  certificateContractText = "baseCard.certificate.contractText",
  certificateConcretingDateText = "baseCard.certificate.concretingDateText",
  certificateDateText = "baseCard.certificate.dateText",
  clientDocumentText = "baseCard.client.documentText",
  clientCreditLimitText = "baseCard.client.creditLimitText",
  clientCreditLimitAvailableText = "baseCard.client.creditLimitAvailableText",
  clientPendencyText = "baseCard.client.pedencyText",
  permissionClientNameText = "baseCard.permission.clientNameText",
  permissionContractText = "baseCard.permission.contractText",
  permissionDataText = "baseCard.permission.dataText",
  concretingRequestConcretingConcreteBatchingPlantText = "baseCard.concretingRequest.concretingConcreteBatchingPlantText",
  concretingRequestConcretingDateText = "baseCard.concretingRequest.concretingDateText",
  concretingRequestConcretingTimeText = "baseCard.concretingRequest.concretingTimeText",
  concretingRequestConcretingIntervalText = "baseCard.concretingRequest.concretingIntervalText",
  concretingRequestObservationText = "baseCard.concretingRequest.observationText",
  concretingRequestRequesterText = "baseCard.concretingRequest.requesterText",
  concretingRequestRequesterPhoneNumberText = "baseCard.concretingRequest.requesterPhoneNumberText",
  concretingRequestConcreteRecipeRequestedQuantityText = "baseCard.concretingRequest.concreteRecipeRequestedQuantityText",
  concretingRequestConcretingRecipeContractedQuantityText = "baseCard.concretingRequest.concretingRecipeContractedQuantityText",
  concretingRequestConcretingRecipeBalanceAvailableText = "baseCard.concretingRequest.concretingRecipeBalanceAvailableText",
  concretingRequestConcreteRecipeQuantityPerConcreteMixerText = "baseCard.concretingRequest.concreteRecipeQuantityPerConcreteMixerText",
  concretingRequestConcreteRecipePieceToBeConcretedText = "baseCard.concretingRequest.concreteRecipePieceToBeConcretedText",
  concretingRequestPumpDescriptionText = "baseCard.concretingRequest.pumpDescriptionText",
  concretingRequestPipingDistanceText = "baseCard.concretingRequest.pipingDistanceText",
  concretingResumeCanceled = "baseCard.concretingResume.canceled",
  concretingResumeDelivered = "baseCard.concretingResume.delivered",
  concretingResumeDischarging = "baseCard.concretingResume.discharging",
  concretingResumeInConstruction = "baseCard.concretingResume.inConstruction",
  concretingResumeInTransit = "baseCard.concretingResume.inTransit",
  concretingResumeNFSE = "baseCard.concretingResume.NFSE",
  concretingResumePreparing = "baseCard.concretingResume.preparing",
  concretingResumeProgrammed = "baseCard.concretingResume.programmed",
  mapTextAgo = "baseCard.map.ago",
  mapTextLastUpdate = "baseCard.map.lastUpdate",
  mapTextNameLabel = "baseCard.map.nameLabel"

}

export interface TranslationBaseCardMessages {
  [BaseCardMessages.statusProgrammedLabelText]: string;
  [BaseCardMessages.statusProgrammedPrefixText]: string;
  [BaseCardMessages.statusPreparingLabelText]: string;
  [BaseCardMessages.statusInTransitLabelText]: string;
  [BaseCardMessages.statusInTransitPrefixText]: string;
  [BaseCardMessages.statusInConstructionLabelText]: string;
  [BaseCardMessages.statusInConstructionPrefixText]: string;
  [BaseCardMessages.statusInConstructionDescriptionText]: string;
  [BaseCardMessages.statusDischargingLabelText]: string;
  [BaseCardMessages.statusDischargingPrefixText]: string;
  [BaseCardMessages.statusDischargingDescriptionText]: string;
  [BaseCardMessages.statusDeliveredLabelText]: string;
  [BaseCardMessages.statusDeliveredDescriptionText]: string;
  [BaseCardMessages.statusCanceledLabelText]: string;
  [BaseCardMessages.statusInvoiceIssuedLabelText]: string;
  [BaseCardMessages.statusInvoiceIssuedPrefixText]: string;
  [BaseCardMessages.volumeText]: string;
  [BaseCardMessages.volumeTotalText]: string;
  [BaseCardMessages.volumeDeliveredText]: string;
  [BaseCardMessages.volumeRemainingText]: string;
  [BaseCardMessages.volumePriceText]: string;
  [BaseCardMessages.installmentNumberText]: string;
  [BaseCardMessages.installmentDueDateText]: string;
  [BaseCardMessages.installmentSettlementDateText]: string;
  [BaseCardMessages.installmentNetValueText]: string;
  [BaseCardMessages.travelEquipmentText]: string;
  [BaseCardMessages.travelPlateText]: string;
  [BaseCardMessages.travelDriverText]: string;
  [BaseCardMessages.travelProgrammedText]: string;
  [BaseCardMessages.travelDocumentNumberText]: string;
  [BaseCardMessages.travelLoadLabelText]: string;
  [BaseCardMessages.concreteRecipeText]: string;
  [BaseCardMessages.contractLabelText]: string;
  [BaseCardMessages.contractDateText]: string;
  [BaseCardMessages.contractSellerText]: string;
  [BaseCardMessages.invoiceContractLabelText]: string;
  [BaseCardMessages.invoiceContractDateText]: string;
  [BaseCardMessages.invoiceNumberText]: string;
  [BaseCardMessages.invoiceDocumentTypeText]: string;
  [BaseCardMessages.invoiceTotalValueText]: string;
  [BaseCardMessages.certificateContractText]: string;
  [BaseCardMessages.certificateConcretingDateText]: string;
  [BaseCardMessages.certificateDateText]: string;
  [BaseCardMessages.clientDocumentText]: string;
  [BaseCardMessages.clientCreditLimitText]: string;
  [BaseCardMessages.clientCreditLimitAvailableText]: string;
  [BaseCardMessages.clientPendencyText]: string;
  [BaseCardMessages.permissionClientNameText]: string;
  [BaseCardMessages.permissionContractText]: string;
  [BaseCardMessages.permissionDataText]: string;
  [BaseCardMessages.concretingRequestConcretingConcreteBatchingPlantText]: string;
  [BaseCardMessages.concretingRequestConcretingDateText]: string;
  [BaseCardMessages.concretingRequestConcretingTimeText]: string;
  [BaseCardMessages.concretingRequestConcretingIntervalText]: string;
  [BaseCardMessages.concretingRequestObservationText]: string;
  [BaseCardMessages.concretingRequestRequesterText]: string;
  [BaseCardMessages.concretingRequestRequesterPhoneNumberText]: string;
  [BaseCardMessages.concretingRequestConcreteRecipeRequestedQuantityText]: string;
  [BaseCardMessages.concretingRequestConcretingRecipeContractedQuantityText]: string;
  [BaseCardMessages.concretingRequestConcretingRecipeBalanceAvailableText]: string;
  [BaseCardMessages.concretingRequestConcreteRecipeQuantityPerConcreteMixerText]: string;
  [BaseCardMessages.concretingRequestConcreteRecipePieceToBeConcretedText]: string;
  [BaseCardMessages.concretingRequestPumpDescriptionText]: string;
  [BaseCardMessages.concretingRequestPipingDistanceText]: string;
  [BaseCardMessages.concretingResumeCanceled]: string;
  [BaseCardMessages.concretingResumeDelivered]: string;
  [BaseCardMessages.concretingResumeDischarging]: string;
  [BaseCardMessages.concretingResumeInConstruction]: string;
  [BaseCardMessages.concretingResumeInTransit]: string;
  [BaseCardMessages.concretingResumeNFSE]: string;
  [BaseCardMessages.concretingResumePreparing]: string;
  [BaseCardMessages.concretingResumeProgrammed]: string;
  [BaseCardMessages.mapTextAgo]: string;
  [BaseCardMessages.mapTextLastUpdate]: string;
  [BaseCardMessages.mapTextNameLabel]: string;

}
